type DimensionRecordType<DimensionsType extends string> = { [x in DimensionsType]?: number | null };

type MeasurerType<DimensionsType extends string> = () => DimensionRecordType<DimensionsType>;

export class GameGridObserver<DimensionsType extends string> {
  private readonly measurers: Record<string, MeasurerType<DimensionsType>> = {};
  private readonly dispatch: ((dimensions: DimensionRecordType<DimensionsType>) => void) | null = null;

  constructor(dispatch: (dimensions: DimensionRecordType<DimensionsType>) => void) {
    window.addEventListener('resize', this.handleResize);
    this.dispatch = dispatch;
  }

  addMeasurer(name: string, measurer: MeasurerType<DimensionsType>): void {
    this.measurers[name] = measurer;
    this.handleResize();
  }

  handleResize = (): void => {
    Promise.all(
      Object.values(this.measurers).map((measurer) => {
        return new Promise<DimensionRecordType<DimensionsType>>((resolve) => {
          setTimeout(() => {
            resolve(measurer());
          });
        });
      })
    ).then((measurements: DimensionRecordType<DimensionsType>[]) => {
      const newDimensions = measurements.reduce((previousValue, currentValue) => {
        return { ...previousValue, ...currentValue };
      }, {});
      this.dispatch?.(newDimensions);
    });
  };
}
